"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateObject = _taggedTemplateLiteral(["\n    font-weight: bold;\n    color: ", ";\n    font-size: ", "em;\n    margin-bottom: ", "em;\n"], ["\n    font-weight: bold;\n    color: ", ";\n    font-size: ", "em;\n    margin-bottom: ", "em;\n"]);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var UserInfoTitle = _styledComponents2.default.p(_templateObject, function (props) {
    return props.theme.userInfo.title.color;
}, function (props) {
    return props.theme.userInfo.title.size;
}, function (props) {
    return props.theme.userInfo.spacingY;
});

UserInfoTitle.displayName = "UserInfoTitle";

exports.default = UserInfoTitle;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/userInfo/userInfoTitle.js
// module id = 1027
// module chunks = 95715928098905 168707334958949